const MESSAGE_STORAGE_KEY = 'app/dashboard/message'

export default{
  MESSAGE_STORAGE_KEY
}
